/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowBudgetAlertMapping extends models.ServiceNowMappingBase {
    getFixupPrototypeFunction() { return ServiceNowBudgetAlertMapping.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowBudgetAlertMapping>): ServiceNowBudgetAlertMapping {
        let obj = Object.assign(new ServiceNowBudgetAlertMapping(), model);
        ServiceNowBudgetAlertMapping.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowBudgetAlertMapping>): ServiceNowBudgetAlertMapping {
        if (!model) return null;
        return ServiceNowBudgetAlertMapping.newInstance(<ServiceNowBudgetAlertMapping> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowBudgetAlertMapping) {
        if (!obj) return;

        models.ServiceNowBudgetAlertMapping.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowBudgetAlertMapping): boolean {
        if (models.ServiceNowMappingBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceNowBudgetAlertMapping.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    description_attributes: Array<models.ServiceNowBudgetAlertDescriptionAttribute>;

}
